export function encodeBase64(value: string): string {
  if (BUILD_PLATFORM === "browser") return btoa(value);
  return Buffer.from(value).toString("base64");
}

export function decodeBase64AsString(value: string): string {
  if (BUILD_PLATFORM === "browser") return atob(value);
  return Buffer.from(value, "base64").toString("ascii");
}
